// eslint-disable-next-line import/no-extraneous-dependencies
import { ScheduledPaymentsCore } from '@royal-payway/scheduled-payments';

// eslint-disable-next-line import/prefer-default-export
export async function getScheduledPayments(bookinIdSP) {
  const coreService = new ScheduledPaymentsCore(
    process.env.REACT_APP_SCHEDULED_PAYMENT_ENVIRONMENT,
    'royal',
    process.env.REACT_APP_SCHEDULED_PAYMENT,
    '',
  ); // NOSONAR
  return coreService.getScheduledPayments(`${Number(bookinIdSP)}`); // NOSONAR
}
